import { ProductDetail as EngineProductDetails } from "@imi-ernd-be/hyselect-engine";
import { withDelete } from "../helpers/withDelete";
import { isPhysicalType } from "../units/constants";
import { toArray } from "../vector";
import { ProductDetails, QualifiedId } from "./types";

export function buildProduct(
  productDetails: EngineProductDetails,
  id: QualifiedId,
): ProductDetails {
  return withDelete(productDetails, {
    articleNumber: productDetails.articleNumber,
    children: toArray(productDetails.children).map((child, index) =>
      buildProduct(child, {
        id: `${id.id}-child-${index + 1}`,
        productSetId: "",
        type: child.productType,
      }),
    ),
    connectionArticleNumber: productDetails.connectionArticleNumber,
    deleted: productDetails.deleted,
    description: buildProductDescriptions(productDetails),
    localArticleNumber: productDetails.localArticleNumber,
    name: productDetails.name,
    otherArticleNumber: productDetails.otherArticleNumber,
    productId: productDetails.productId,
    productType: productDetails.productType,
    qualifiedId: {
      id: id.id,
      productSetId: id.productSetId || null,
      type: id.type,
    },
    quantityEditable: productDetails.quantityEditable,
    quantityMultiplier: productDetails.quantityMultiplier,
  });
}

function buildProductDescriptions(
  productDetails: EngineProductDetails,
): ProductDetails["description"] {
  return toArray(productDetails.description).flatMap((item) =>
    withDelete(
      item,
      toArray(item.description).map((value) => ({
        id: item.translationKey.split(".").pop() ?? "",
        physicalType: isPhysicalType(item.physicalType)
          ? item.physicalType
          : null,
        translationKey: item.translationKey,
        value: value ? value.toString() : null,
      })),
    ),
  );
}
